












import Vue from "vue";
import anime from "animejs";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { TweenLite, TweenMax, TimelineLite, TimelineMax, Elastic, Back, Sine } from "gsap";

enum ViewTransitionType {
  FROM_OVERVIEW_TO_LIST,
  FROM_LIST_TO_OVERVIEW,
  // FROM_CNTRBT_TO_OVERVIEW,
  // FROM_OVERVIEW_TO_CNTRBT,
  OTHER,
}

const eventHeaderSelector = "#event-header-card";
const overviewHeaderSelector = "#overview-header-card";

@Component({})
export default class ViewTransition extends Vue {
  @Prop({ default: "v-layout" }) private tag: string;

  private rectToFlip: any;
  private targetElStyle: any;
  private fromEventElId: string;
  private activeViewTransitionType: ViewTransitionType;
  private fromElSelector: string;
  private toElSelector: string;
  // private enterTimeline: anime.AnimeTimelineInstance;
  private enterTimeline: TimelineLite;
  // private leaveTimeline: anime.AnimeTimelineInstance;
  private leaveTimeline: TimelineLite;

  private targetEl: HTMLElement;
  private siblings: NodeListOf<HTMLElement>;

  private animPosition = 0;

  @Watch("$route")
  private routeChanged(to: Route, from: Route) {
    this.activeViewTransitionType = this.getTransitionType(to, from);

    switch (this.activeViewTransitionType) {
      case ViewTransitionType.FROM_OVERVIEW_TO_LIST:
        this.fromElSelector = "[data-selected-event=id-" + to.params.eventId + "]";
        this.toElSelector = eventHeaderSelector;
        break;
      case ViewTransitionType.FROM_LIST_TO_OVERVIEW:
        this.fromElSelector = eventHeaderSelector;
        this.toElSelector = overviewHeaderSelector;
        break;
      // case ViewTransitionType.FROM_OVERVIEW_TO_CNTRBT:
      //   this.fromElSelector = "[data-selected-event=id-" + to.params.eventId + "]";
      //   this.toElSelector = eventHeaderSelector;
      //   break;
      // case ViewTransitionType.FROM_CNTRBT_TO_OVERVIEW:
      //   this.fromElSelector = eventHeaderSelector;
      //   this.toElSelector = overviewHeaderSelector;
      //   break;
      default:
        this.fromElSelector = "";
        this.toElSelector = "";
        break;
    }
  }

  private getTransitionType(to: Route, from: Route): ViewTransitionType {
    let transitionType = ViewTransitionType.OTHER;
    if (from.name === "overview" && to.name === "event") {
      transitionType = ViewTransitionType.FROM_OVERVIEW_TO_LIST;
    } else if (from.name === "event" && to.name === "overview") {
      transitionType = ViewTransitionType.FROM_LIST_TO_OVERVIEW;
    } else if (from.name === "contribute" && to.name === "contribute-overview") {
      transitionType = ViewTransitionType.FROM_LIST_TO_OVERVIEW;
    } else if (from.name === "contribute-overview" && to.name === "contribute") {
      transitionType = ViewTransitionType.FROM_OVERVIEW_TO_LIST;
    }
    return transitionType;
  }

  private beforeEnter(el: HTMLElement) {
    this.enterTimeline = new TimelineLite({ paused: true });

    if (this.activeViewTransitionType !== ViewTransitionType.OTHER) {
      this.targetEl = el.querySelector(this.toElSelector);
      this.siblings = this.targetEl.parentElement.querySelectorAll("div:not(" + this.toElSelector + ")");

      TweenMax.set(this.targetEl, {
        // width: this.rectToFlip.width,
        // height: this.rectToFlip.height,
        x: this.rectToFlip.x,
        y: this.rectToFlip.y,
        // transformOrigin: "left",
      });

      // let cardContent = this.targetEl.querySelector(".card-content");
      // if (cardContent) {
      //   TweenMax.set(cardContent, {
      //     autoAlpha: 0,
      //   });
      // }
    }
  }

  private enterAnimation(el: HTMLElement, done: any) {

    let computedStyle;
    let targetElWidth;
    let targetElHeight;

    switch (this.activeViewTransitionType) {
      case ViewTransitionType.FROM_OVERVIEW_TO_LIST:

        // TweenMax.set(this.targetEl, {
        //   width: "",
        //   height: "",
        // });

        // get ending width and height
        computedStyle = getComputedStyle(this.targetEl);
        targetElWidth = computedStyle.width;
        targetElHeight = computedStyle.height;
        // let targetElWidthInPX = Number(targetElWidth.split("px")[0]);
        // let targetElHeightInPX = Number(targetElHeight.split("px")[0]);

        // let percentageWidth = this.rectToFlip.width / targetElWidthInPX;
        // let percentageHeight = this.rectToFlip.height / targetElHeightInPX;

        TweenMax.set(this.targetEl, {
          width: this.rectToFlip.width,
          height: this.rectToFlip.height,
        });

        // TweenMax.set(this.targetEl, {
        //   scaleX: percentageWidth,
        //   scaleY: percentageHeight,
        // });

        this.enterTimeline.add(
          TweenMax.to(this.targetEl, 0.5, {
            ease: Elastic.easeOut.config(0.8, 1),
            force3D: true,
            clearProps: "all",
            overwrite: "all",
            css: {
              width: targetElWidth,
              height: targetElHeight,
              // scaleX: 1,
              // scaleY: 1,
              x: 0,
              y: 0,
              clearProps: "width,height,transform,zIndex",
            }
            }
        ), 0);

        this.enterTimeline.add(
          TweenMax.set(this.siblings, {
            autoAlpha: 0,
          }), 0
        );

        this.enterTimeline.add(
          TweenMax.to(this.siblings, 0.3, {
            autoAlpha: 1,
          }), 0.5
        );
        break;

      case ViewTransitionType.FROM_LIST_TO_OVERVIEW:

        // TweenMax.set(this.targetEl, {
        //   width: "",
        //   height: "",
        // });

        // get ending width and height
        computedStyle = getComputedStyle(this.targetEl);
        targetElWidth = computedStyle.width;
        targetElHeight = computedStyle.height;

        TweenMax.set(this.targetEl, {
          width: this.rectToFlip.width,
          height: this.rectToFlip.height,
        });

        this.enterTimeline.add([
          TweenMax.to(this.targetEl, 0.5, {
            ease: Elastic.easeOut.config(0.8, 1),
            // ease: Sine.easeInOut,
            force3D: true,
            // x: 0,
            // y: 0,
            width: targetElWidth,
            height: targetElHeight,
            zIndex: 10,
            // rotationY: -180,
            clearProps: "width,height,transform, zIndex",
            overwrite: "all",
          }),
          TweenMax.from(this.siblings, 0.5, {
            autoAlpha: 0,
          }),
          ],
        );
        break;

      default:

        this.enterTimeline.add(TweenLite.from(el, 0.5, {
          autoAlpha: 0,
        }));
        break;
    }

    let cardContent = this.targetEl ? this.targetEl.querySelector(".card-content") : null;
    if (cardContent) {
      // TweenMax.set(cardContent, {
      //   opacity: 0,
      // });

      this.leaveTimeline.add(
        TweenMax.fromTo(cardContent, 0.5, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
      }), 0.5);
    }

    this.enterTimeline.add(TweenLite.set(el, {
      onComplete: done,
    }));

    this.enterTimeline.play();
  }

  private enter(el: HTMLElement, done: any) {

    this.enterAnimation(el, done);
  }

  private leave(el: HTMLElement, done: () => void) {

    this.leaveAnimation(el, done);
  }

  private leaveAnimation(el: HTMLElement, done: any) {
    switch (this.activeViewTransitionType) {
      case ViewTransitionType.FROM_OVERVIEW_TO_LIST:
      case ViewTransitionType.FROM_LIST_TO_OVERVIEW:
        if (this.fromElSelector) {
          let elSelected = el.querySelector(this.fromElSelector);
          if (elSelected) {
            this.rectToFlip = elSelected.getBoundingClientRect();
            this.rectToFlip.x = (elSelected as HTMLElement).offsetLeft;
            this.rectToFlip.y = (elSelected as HTMLElement).offsetTop;
          }
        }
        break;
      default:
        break;
    }

    let targetEl: HTMLElement;
    let siblings: any;

    // this.leaveTimeline = anime.timeline({ autoplay: false });

    this.leaveTimeline = new TimelineLite({ paused: true });

    if (this.activeViewTransitionType !== ViewTransitionType.OTHER) {
      targetEl = el.querySelector(this.fromElSelector);
      if (this.activeViewTransitionType === ViewTransitionType.FROM_OVERVIEW_TO_LIST) {
        siblings = Array.from(targetEl.parentElement.children).filter((item) => (item as HTMLElement).dataset.selectedEvent !== targetEl.dataset.selectedEvent);
      } else if (this.activeViewTransitionType === ViewTransitionType.FROM_LIST_TO_OVERVIEW) {
        siblings = Array.from(targetEl.parentElement.children).filter((item) => item !== targetEl);
      }
      // siblings = targetEl.parentElement.children;
      // parentSiblings = Array.from(el.children).filter((item) => !(item.querySelector(this.fromElSelector)));
      let overviewHeader = el.querySelector(overviewHeaderSelector);
      if (overviewHeader) {
        // this.leaveTimeline.add({
        //   targets: overviewHeader,
        //   duration: 500,
        //   opacity: 0,
        // });

        this.leaveTimeline.add(TweenLite.to(overviewHeader, 0.5, {
          autoAlpha: 0,
        }), 0,
        );
      }

      let cardContent = targetEl.querySelector(".card-content");
      if (cardContent) {
        this.leaveTimeline.add(TweenMax.to(cardContent, 0.5, {
          autoAlpha: 0,
        }), 0);
      }

      this.leaveTimeline.add(TweenMax.to(siblings, 0.5, {
        autoAlpha: 0,
        // onComplete: done,
        }), 0);

      this.leaveTimeline.add(TweenMax.to(targetEl, 0.5, {
          autoAlpha: 1,
          overwrite: "all",
          onComplete: done,
        }), 0);

      this.leaveTimeline.play();
    } else {

      TweenMax.to(el, 0.5, {
        autoAlpha: 0,
        onComplete: done,
      });
    }
  }
}
